(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('race-resume', {
            parent: 'entity',
            url: '/race-resume',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.raceResume.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race-resume/race-resumes.html',
                    controller: 'RaceResumeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('raceResume');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('race-resume-detail', {
            parent: 'race-resume',
            url: '/race-resume/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.raceResume.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race-resume/race-resume-detail.html',
                    controller: 'RaceResumeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('raceResume');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RaceResume', function($stateParams, RaceResume) {
                    return RaceResume.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'race-resume',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('race-resume-detail.edit', {
            parent: 'race-resume-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-resume/race-resume-dialog.html',
                    controller: 'RaceResumeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RaceResume', function(RaceResume) {
                            return RaceResume.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race-resume.new', {
            parent: 'race-resume',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-resume/race-resume-dialog.html',
                    controller: 'RaceResumeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                totalAmountRunners: null,
                                finishDate: null,
                                startDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('race-resume', null, { reload: 'race-resume' });
                }, function() {
                    $state.go('race-resume');
                });
            }]
        })
        .state('race-resume.edit', {
            parent: 'race-resume',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-resume/race-resume-dialog.html',
                    controller: 'RaceResumeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RaceResume', function(RaceResume) {
                            return RaceResume.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race-resume', null, { reload: 'race-resume' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race-resume.delete', {
            parent: 'race-resume',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race-resume/race-resume-delete-dialog.html',
                    controller: 'RaceResumeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RaceResume', function(RaceResume) {
                            return RaceResume.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race-resume', null, { reload: 'race-resume' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
